export default __webpack_public_path__ + "static/media/kids 1.04722b32.png";